import React, {
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';
import { useAppDispatch } from "hooks/redux";
import { Dropdown } from "components/common/Dropdown";
import {
  bulkImportActions,
  InvalidEntity,
} from "store/slices/bulkImport";
import { RevenueTypeOptions } from "utils/constants";
import { DropdownRendererWrapper } from '../styled';
import { ICellEditorParams } from '@ag-grid-community/core';
import { useClickOutside } from 'hooks/useClickOutside';

interface Props extends ICellEditorParams {
  data: InvalidEntity;
  value: InvalidEntity;
  disabled?: boolean;
  maxHeight?: number;
  width: number;
}

export const RevenueTypeDropdownRenderer = forwardRef(({
  data,
  value,
  disabled,
  maxHeight,
  width,
  stopEditing,
}: Props, ref) => {
  const dispatch = useAppDispatch();
  const wrapperRef = React.createRef<HTMLDivElement>();
  const [selectedValue, setSelectedValue] = useState(value);
  useClickOutside(wrapperRef, stopEditing);

  const handleChange = (newValue: any[]) => {
    setSelectedValue(newValue[0]);

    dispatch(bulkImportActions.updateInvalidProduct({
      id: data.id,
      entity: {
        createNew: data.entity.createNew,
        id: null,
        name: null,
      },
      revenueType: {
        createNew: data.revenueType.createNew,
        id: RevenueTypeOptions?.find((opt) => opt.value === newValue[0]?.label)?.value || null,
      },
    }));

    stopEditing();
  };

  const selected = RevenueTypeOptions?.find((opt) => opt.value === value.id);

  useImperativeHandle(ref, () => ({
    getValue() {
      return selectedValue;
    },
  }));

  if (disabled) return null;

  return (
    <DropdownRendererWrapper
      ref={wrapperRef}
      style={{ width: `${width}px` }}
    >
      <Dropdown
        ref={ref}
        values={selected ? [selected] : []}
        options={RevenueTypeOptions}
        labelField="label"
        valueField="value"
        searchBy="label"
        onChange={handleChange}
        borderless
        disabled={disabled}
        error={!disabled && !selected ? ' ' : undefined}
        maxHeight={maxHeight}
        keepOpen
      />
    </DropdownRendererWrapper>
  );
});
